module.exports = __webpack_public_path__ + "img/118.fbfffec8.jpg";